import React, { CSSProperties, Ref } from 'react';

import Spinner, { SpinnerType } from '@cobalt/react-spinner';
import Flex from '@cobalt/react-flex';

interface Props {
  size?: 'micro' | 'tiny' | 'small' | 'medium' | 'large' | 'xlarge';
  style?: CSSProperties;
  forwardedRef?: Ref<SpinnerType>;
  isWrap?: boolean;
}

export default function PageLoading(props: Props) {
  const { size = 'large', style, forwardedRef, isWrap = false } = props;
  const spinner = (
    <Spinner
      data-testid="spinner"
      forwardedRef={forwardedRef}
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        ...style,
      }}
      size={size}
    />
  );
  return isWrap ? (
    <>
      <Flex data-testid="wrappedFlex" style={{ position: 'relative' }}>
        <Flex direction="column" width="100%" height="100vh" style={{ position: 'absolute', zIndex: 99 }}>
          {spinner}
        </Flex>
      </Flex>
    </>
  ) : (
    spinner
  );
}
